import gql from 'graphql-tag';
import { ProductImageAllData } from '../fragments';

export default gql`
mutation adminUpdateProductMainImage (
    $product_id: ID!
    $file_name: String!
    $base64_image: String!
) {
    adminUpdateProductMainImage (input: {
        product_id: $product_id
        file_name: $file_name
        base64_image: $base64_image
    }) {
        ...ProductImageAllData
    }
}
${ProductImageAllData}
`;



// WEBPACK FOOTER //
// ./src/api/graphql/mutations/adminUpdateProductMainImage.ts